// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const counter_GROUP_POSTS = ["%(counter)s pr\u00edspevok", "%(counter)s pr\u00edspevky", "%(counter)s pr\u00edspevkov"];
export const SHOW_ALL_GROUPS = "\u010eal\u0161ie skupiny";
